export const DealType = {
    Private_Auction: 'private_auction',
    Private_Deal: 'private_deal',
    Guaranteed_Deal: 'guaranteed_deal',
};

export const DEAL_TYPE_OPTIONS = [
    { value: DealType.Private_Auction, label: 'Private Auction' },
    { value: DealType.Private_Deal, label: 'Preferred Deal' },
    { value: DealType.Guaranteed_Deal, label: 'Programmatic Guaranteed', disabled: true },
];

const TYPE_MAPPING = {};
DEAL_TYPE_OPTIONS.map(deal => (TYPE_MAPPING[deal.value] = deal));

export const DEAL_TYPE_MAPPING = TYPE_MAPPING;

export const DealCategory = {
    Private: 'private',
    Curated: 'curated',
    Guaranteed: 'guaranteed',
};

export const DEAL_CATEGORY_SELECT_TABS = [
    { value: DealCategory.Private, label: 'Private Deals' },
    { value: DealCategory.Curated, label: 'Curated Deals' },
];

const CATEGORY_MAPPING = {};
DEAL_CATEGORY_SELECT_TABS.map(deal => (CATEGORY_MAPPING[deal.value] = deal));

export const DEAL_CATEGORY_MAPPING = CATEGORY_MAPPING;

// Used in the ad summary page
export const DEAL_CATEGORY_AD_DETAILS_MAPPING = {
    [DealCategory.Private]: { value: DealCategory.Private, label: 'Private Deal(s)' },
    [DealCategory.Curated]: { value: DealCategory.Curated, label: 'Curated Deal(s)' },
    [DealCategory.Guaranteed]: { value: DealCategory.Curated, label: 'Guaranteed Deal' },
};
